var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('datatable',{ref:"datatable",attrs:{"user":_vm.user,"isAuth":_vm.isAuth},on:{"destroy":_vm.destroy,"create":_vm.create}}),_vm._v(" "),_c('fab',{attrs:{"type":'index',"user":_vm.user,"isAuth":_vm.isAuth},on:{"reload":_vm.reload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58d1dff0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/management/invoices/views/html/Index.html
// module id = null
// module chunks = 